<script>
import { status, VolumeUnits } from 'pando-constants';
import { isEmpty, cloneDeep } from 'lodash';
import { bfrMapper } from '../../shipper/src/constants/mdm-v2/pageConstants';
import VolumeFormulaConvertor from '../helpers/volume-formula-converter';
import { getPanValidation } from '../lib/common';

const MDM = {
  data() {
    return {
      // following are to manage the create, update
      currentSection: '',
      selectedRow: null,
      // following are for the add/edit form
      isEditForm: true,
      showForm: false,
      addFormConstants: [],
      // following are for upload functionality
      rejectCount: 0,
      rejectEvent: null,
      maxRetryCount: 150,
      currentCount: 0,
      // following are used for the user search popup
      defaultValues: {}, // default values to be shown in the input fields
      searchedParams: {}, // user input data
      // variable for listing functionality
      loadCheck: true,
      sectionHeaders: [],
      filterParams: {}, // filter params
      createDnSelectMaterialLoading: true,
      uploadStatusResponse: {},
    };
  },
  created() {
    // Getting current section name from route url
    this.currentSection = this.$router.history.current.name.toLowerCase();
    this.setConstants();
    this.searchParameters.forEach((param) => {
      this.defaultValues[`${param.query}`] =
        this.filter[`${param.query}`] || null;
    });
    this.$store.commit('mdmV2/initialReset', []);
  },
  computed: {
    preferredVolumeUnit(){
      return this.$preferredVolumeUnit();
    },
    searchParameters() {
      const id = 0;
      const configSearchParameters =
        this.configHeaders &&
        this.configHeaders
          .filter(header => header.is_searchable)
          .map(_data => ({
            id: id + 1,
            name: _data.head,
            query: _data.label,
          }));
      let searchConstants = null;
      if (this.currentSection === 'contracttsd') {
        const configHeaders = (this.mdmBoostrap && this.mdmBoostrap[this.currentSection] &&
         this.mdmBoostrap[this.currentSection].header_mappings) || {};
        searchConstants = this.searchConstants[this.currentSection]
          .filter(searchConstant => (Object.keys(configHeaders).includes(searchConstant.name) ||
          searchConstant.name === 'Transporter'));
      }
      if (this.currentSection === 'freight_zone' && this.searchConstants[this.currentSection]) {
        searchConstants = this.searchConstants[this.currentSection].filter((item) => {
          if (typeof item.configCheck === 'function') {
            return item.configCheck(this.configurations);
          }
          return true;
        });
      }
      const specificSearchParameters =
        searchConstants ||
        (this.searchConstants && this.searchConstants[this.currentSection]) ||
        configSearchParameters;
      if (
        (this.isMieone || this.overrideDefaultSearchParms) &&
        specificSearchParameters
      ) {
        return specificSearchParameters;
      } else if (specificSearchParameters) {
        let result = Object.assign(
          [],
          (!['vehicle'].includes(this.currentSection) ? this.defaultSearchParameters : []),
          specificSearchParameters,
        );
        if (this.currentSection === 'legal_entity' && this.$hasFeature('primary_legal_entity')) {
          result = this.getLegalEntitySearchConstants(result);
        }
        return result;
      }
      return Object.assign([], this.defaultSearchParameters);
    },
    showEmptyState() {
      return (
        (this.all && this.all.length) === 0 &&
        !this.isLoading &&
        !this.showAddForm
      );
    },
    menuOptions() {
      return this.Menu.filter(element =>
        (element.permission ? this.$hasPermission(element.permission) : true) &&
        (element.config ? this.configurations[element.config] : true),
      );
    },
    seletedCategory() {
      const section = bfrMapper[this.currentSection] || this.currentSection;
      const val = this.Menu.find(
        element => element.id.toLowerCase() === section,
      );
      return val;
    },
    enableSearchPopup() {
      return !this.hideSearch.includes(this.currentSection);
    },

    /**
     * Upload button permission - export_${currentSection}
     * Upload sample file retrieved from constant file of a section
     * Add button permission - create_${currentSection}
     */
    buttonsList() {
      const buttonList =
        this.actionButtons &&
        this.actionButtons.map((val) => {
          const button = val;
          if (button.id === 'upload') {
            button.permission = `import_${this.currentSection}`;
            const dropdownIndex = button.dropdownList.findIndex(
              val => val.id === 'bulk_upload',
            );
            if (dropdownIndex !== -1) {
              const dropdownObj = button.dropdownList[dropdownIndex];

              if (['contract', 'driver', 'contracttsd', 'destination_charge', 'source_charge',
                'activity_time', 'transporter', 'consignee', 'bfr'].includes(this.currentSection)) {
                button[dropdownIndex] = Object.assign(dropdownObj, {
                  sampleFileEmitMethod: 'getExcel',
                });
              } else {
                button[dropdownIndex] = Object.assign(dropdownObj, {
                  sampleFileName:
                    this.uploadSampleFileName &&
                    this.uploadSampleFileName[this.currentSection],
                });
              }
              if (this.currentSection === 'vehicledetail') {
                button[dropdownIndex] = Object.assign(dropdownObj, {
                  name: 'Vehicle Availablity',
                });
                // Find and modify second item (vehicleBulkUpload) 
                const vehicleBulkIndex = button.dropdownList.findIndex(
                  val => val.id === 'vehicleDetailBulkUpload'
                );
                if (vehicleBulkIndex !== -1) {
                  button.dropdownList[vehicleBulkIndex] = Object.assign(button.dropdownList[vehicleBulkIndex], {
                    name: 'Vehicle Bulk Upload',
                    // sampleFileName: this.uploadSampleFileName.vehicleDetailBulkUpload,
                  });
                }
              }
            }
          } else if (button.id === 'add') {
            button.permission = `create_${this.currentSection}`;
            if (['contract', 'detention'].includes(this.currentSection)) {
              button.show = false;
            }
          } else if (button.id === 'stop') {
            if (['bfr'].includes(this.currentSection)) {
              button.permission = `stop_${this.currentSection}`;
              button.show = true;
            }
          } else if (button.id === 'reject_list') {
            if (this.rejectCount > 0) {
              button.show = true;
            } else {
              button.show = false;
            }
          } else if (button.id === 'export') {
            button.permission = `export_${this.currentSection}`;
          }
          return button;
        });
      return buttonList;
    },
    // used to show edit button/ not
    showEdit() {
      if (!this.skipEditPermission) {
        return this.$hasPermission(`update_${this.currentSection}`);
      }
      return true;
    },
  },
  methods: {
    getLegalEntitySearchConstants(specificSearchParameters) {
      let result = specificSearchParameters;
      if (Array.isArray(specificSearchParameters)) {
        let index = 0;
        result = result.reduce((acc, item) => {
          let obj = Object.assign(item, { id: index++ });
          if (item.query === 'legal_entity_code') {
            obj = Object.assign(
              obj,
              {
                name: 'Pando Legal Entity Code',
              },
            );
            acc.push(
              obj,
              {
                id: index++,
                name: 'Legal Entity Code',
                query: 'client_legal_entity_code',
              },
            );
          } else {
            acc.push(obj);
          }
          return acc;
        }, []);
      }
      return result;
    },
    // following is used to set constants
    setConstants() {
      const headers = this.listHeaders && this.listHeaders[this.currentSection];
      // check for permission or feature
      this.sectionHeaders = this.$checkMenuOptions(
        headers,
        this.configurations,
      );
      this.addFormConstants =
        this.formConstants && this.formConstants[this.currentSection];
      if (this.currentSection === 'freight_zone') {
        if (this.sectionHeaders) {
          this.sectionHeaders = this.sectionHeaders.filter((item) => {
            if (typeof item.configCheck === 'function') {
              return item.configCheck(this.configurations);
            }
            return true;
          });
        }
        if (this.addFormConstants) {
          this.addFormConstants = this.addFormConstants.filter((item) => {
            if (typeof item.configCheck === 'function') {
              return item.configCheck(this.configurations);
            }
            return true;
          });
        }
      }
      if (this.currentSection === 'legal_entity' && this.$hasFeature('primary_legal_entity')) {
        this.mutateLeFormConstants();
        this.mutateLeListHeaders();
      }
      if (this.currentSection === 'vehicle'){
        // remove CFT header
        this.sectionHeaders = this.sectionHeaders.filter((item) =>  item.column !== 'cft');
        // add CBM Header
        this.sectionHeaders.push({
          id: this.sectionHeaders.length + 1,
          title: this.preferredVolumeUnit,
          column: this.preferredVolumeUnit.toLowerCase(),
          tlabel: `MDM_VOLUME_${this.preferredVolumeUnit}`,
          show: true,
          colSpan: 3,
        });
      }
      if (this.currentSection === 'material' && this.preferredVolumeUnit !== VolumeUnits.CFT) {
         // remove CFT header
        this.sectionHeaders = this.sectionHeaders.filter((item) =>  item.column !== 'box_volume');
        // add CBM Header
        this.sectionHeaders.push({
          id: this.sectionHeaders.length + 1,
          title: `Volume (${this.preferredVolumeUnit})`,
          column: `box_volume_${this.preferredVolumeUnit.toLowerCase()}`,
          tlabel: `MDM_VOLUME_${this.preferredVolumeUnit}`,
          show: true,
          colSpan: 3,
        });
      }
      if (this.currentSection === 'vehicle') {
        // modify based on vehicle dimensions
        this.sectionHeaders = this.sectionHeaders.map((item) => {
          let obj = {};
          if (item.column === 'length') {
            obj = {
              title: `Length (${this.vehicleDimensionsUOM})`,
              column: 'length',
              tlabel: `MDM_LENGTH_IN_${this.vehicleDimensionsUOM.toUpperCase()}`,
            };
          } else if (item.column === 'breadth') {
            obj = {
              title: `Breadth (${this.vehicleDimensionsUOM})`,
              column: 'breadth',
              tlabel: `MDM_BREADTH_IN_${this.vehicleDimensionsUOM.toUpperCase()}`,
            };
          } else if (item.column === 'height') {
            obj = {
              title: `Height (${this.vehicleDimensionsUOM})`,
              column: 'height',
              tlabel: `MDM_HEIGHT_IN_${this.vehicleDimensionsUOM.toUpperCase()}`,
            };
          }
          return Object.assign(item, obj);
        });
      }
    },
    mutateLeListHeaders() {
      if (this.sectionHeaders) {
        let index = 0;
        this.sectionHeaders = this.sectionHeaders.reduce((acc, item) => {
          let result = Object.assign(item, { id: index++ });
          if (item.column === 'legal_entity_code') {
            result = Object.assign(result, {
              title: 'Pando Legal Entity Code',
              tlabel: 'PANDO_LEGAL_ENTITY_CODE',
            });
            acc.push(
              result,
              { id: index++, title: 'Legal Entity Code', column: 'client_legal_entity_code', tlabel: 'LEGAL_ENTITY_CODE', truncateOn: 30, show: true, colSpan: 3 },
            );
          } else {
            acc.push(result);
          }
          return acc;
        }, []);
      }
    },
    mutateLeFormConstants() {
      if (this.addFormConstants) {
        let index = 0;
        this.addFormConstants = this.addFormConstants.reduce((acc, item) => {
          let result = Object.assign(item, { id: index++ });
          if (item.paramKey === 'legal_entity_code') {
            result = Object.assign(result, {
              title: 'Pando Legal Entity Code',
              tlabel: 'PANDO_LEGAL_ENTITY_CODE',
            });
            acc.push(
              result,
              { id: index++, title: 'Legal Entity Code', tlabel: 'LEGAL_ENTITY_CODE', type: 'input', paramKey: 'client_legal_entity_code', disabled: false, required: true },
            );
          } else {
            acc.push(result);
          }
          return acc;
        }, []);
      }
    },
    // following are used for ADD/UPDATE slider
    openSlider() {
      this.showForm = true;
    },
    openAddSlider() {
      this.isEditForm = false;
      this.selectedRow = {};
      this.openSlider();
      // this.freightForwarderDisable(false);
    },
    closeSlider() {
      this.showForm = false;
      this.selectedRow = {};
      this.isEditForm = false;
    },
    openEditForm(data) {
      this.selectedRow = data;
      this.isEditForm = true;
      // this.freightForwarderDisable(true);
      this.openSlider();
    },
    // following are used for ADD/UPDATE api call
    getAddFormIndexById(id) {
      return this.addFormConstants.findIndex(val => val.id === id);
    },
    constructConsigneePayload(data) {
      data.status = data.status ? 1 : 2;
      data.loading_time = {
        start: data.loading_time_start,
        end: data.loading_time_end,
      };
      data.unloading_time = {
        start: data.unloading_time_start,
        end: data.unloading_time_end,
      };
      delete data.unloading_time_start;
      delete data.unloading_time_end;
      delete data.loading_time_start;
      delete data.loading_time_end;
      return data;
    },
    async add(values) {
      try {
        let data = values;
        if (this.currentSection === 'consignee') {
          data = this.constructConsigneePayload(data);
        }
        if (this.currentSection === 'user' || this.currentSection === 'users') {
          data = this.constructUserPayload(data);
        }
        if (this.currentSection === 'transshipment') {
          data = this.constructAddTransshipmentPayload(data);
        }
        this.addFormConstants.forEach((item) => {
          if (
            item.type === 'MultiSelectList' &&
            !isEmpty(data[item.paramKey])
          ) {
            if (this.currentSection === 'shipmethod') {
              data[item.paramKey] = data[item.paramKey].map(val => ({
                code: val.code,
                description: val.description,
                service: val.service,
              }));
            } else {
              data[item.paramKey] = data[item.paramKey].map(val => val.id);
            }
          }
          if (item.isArray) {
            data[item.paramKey] = data[item.paramKey].split(' ');
          }
          // Handling for array of items with index
          if (item.type === 'array') {
            if (data[item.paramKey]) {
              data[item.paramKey] = data[item.paramKey].map(it => it[item.itemKey]);
            }
          }
          if (item.paramKey === 'updated_by' && this.isMieone) {
            data[item.paramKey] =
              (this.currentUser && this.currentUser.email) || '';
          }
        });
        if(this.currentSection === 'vehicle'){
          const addFormConstantsParamKeys = new Set(this.addFormConstants.map(item => item.paramKey));
          const diffBwAddFormConstants = this.computedAddFormConstants.filter((item) => !addFormConstantsParamKeys.has(item.paramKey)) || [];
          if(diffBwAddFormConstants.length && values.cbm){
            values.cft = new VolumeFormulaConvertor().convertToSystem(this.preferredVolumeUnit, values.cbm)
            delete values.cbm; // remove cbm 
          }
        }
        const requiredFields = this.addFormConstants.filter(
          item =>
            item.required &&
            !item.ignore_field &&
            (item.feature ? this.$hasFeature(item.feature) : true),
        );
        let errorFileds = '';
        if (this.currentSection === 'transporter' && this.$hasFeature('is_pan_mandate_for_invoice_creation')) {
          const { pan_no } = values;
          if (!getPanValidation(pan_no)) {
             errorFileds = 'PAN Number is Invalid';
          }
        }
        requiredFields.forEach((item) => {
          if (this.isEmpty(data[item.paramKey]) && !errorFileds) {
            if (item.paramKey === 'cft' && this.preferredVolumeUnit !== VolumeUnits.CFT){
              errorFileds = `${this.preferredVolumeUnit} is required`;
            } else {
              errorFileds = `${item.title} is required`;
            }
          }
        });
        this.addFormConstants.forEach((item) => {
          if (item.minValue && data[item.paramKey] < item.minValue) {
            errorFileds = `${item.title} should be greater than ${item.minValue}`;
          }
        });
        this.addFormConstants.forEach((item) => {
          if (
            item.maxLength &&
            data[item.paramKey] &&
            data[item.paramKey].length > item.maxLength
          ) {
            errorFileds = `${item.title} value should not be greater than ${item.maxLength} characters.`;
          }
        });
        this.addFormConstants.forEach((item) => {
          if (item.maxValue && Number(data[item.paramKey]) > item.maxValue) {
            errorFileds = `${item.title} should be less than ${item.maxValue}`;
          }
        });
        if (errorFileds) {
          this.$errorMessage({ message: errorFileds });
          return false;
        }
        const result = await this.$store.dispatch('mdmV2/create', {
          section: this.currentSection,
          data,
          isMieone: this.isMieone,
        });
        if (!result || result.error) {
          if (result.error === 'ERR_DUPLICATE_REFERENCE_ID') {
            this.$errorMessage({ message: this.$t('DUPLICATE_REFERENCE_ID') });
          } else {
            this.$errorMessage({ message: this.$t(result.error) });
          }
        } else {
          this.closeSlider();
          this.$success({ message: this.$t('MDM_ADD_RECORD') });
        }
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async update(values) {
      try {
        const sections = {
          carton: 'code',
          carrier: 'code',
          shipmethod: 'code',
        };
        let data = values;
        if (this.currentSection === 'consignee') {
          data = this.constructConsigneePayload(data);
        }
        if (this.currentSection === 'user' || this.currentSection === 'users') {
          data = this.constructUserPayload(data);
        }
        if (this.currentSection === 'transshipment') {
          data = this.constructUpdateTransshipmentPayload(data);
        }
        this.addFormConstants.forEach((item) => {
          if (item.type === 'MultiSelectList') {
            data[item.paramKey] = data[item.paramKey].map(
              val => val && (val.id || val),
            );
          }
          if (item.isArray) {
            data[item.paramKey] = data[item.paramKey].split(',');
          }
          // Handling for array of items with index
          if (item.type === 'array') {
            data[item.paramKey] = data[item.paramKey].map(it => it[item.itemKey]);
          }
          if (item.paramKey === 'updated_by' && this.isMieone) {
            data[item.paramKey] =
              (this.currentUser && this.currentUser.email) || '';
          }
        });
        if(this.currentSection === 'vehicle'){
          const addFormConstantsParamKeys = new Set(this.addFormConstants.map(item => item.paramKey));
          const diffBwAddFormConstants = this.computedAddFormConstants.filter((item) => !addFormConstantsParamKeys.has(item.paramKey)) || [];
          if(diffBwAddFormConstants.length && values.cbm){
            values.cft = new VolumeFormulaConvertor().convertToSystem(this.preferredVolumeUnit, values.cbm)
            delete values.cbm; // remove cbm 
          }
        }
        const requiredFields = this.addFormConstants.filter(
          item =>
            item.required &&
            !item.ignore_field &&
            (item.feature ? this.$hasFeature(item.feature) : true),
        );
        let errorFileds = '';
        if (this.currentSection === 'transporter' && this.$hasFeature('is_pan_mandate_for_invoice_creation')) {
          const { pan_no } = values;
          if (!getPanValidation(pan_no)) {
             errorFileds = 'PAN Number is Invalid';
          }
        }
        requiredFields.forEach((item) => {
          if (this.isEmpty(data[item.paramKey]) && !errorFileds) {
            errorFileds = `${item.title} is required`;
          }
        });
        this.addFormConstants.forEach((item) => {
          if (item.minValue && data[item.paramKey] < item.minValue) {
            errorFileds = `${item.title} should be greater than ${item.minValue}`;
          }
        });
        this.addFormConstants.forEach((item) => {
          if (
            item.maxLength &&
            data[item.paramKey] &&
            data[item.paramKey].length > item.maxLength
          ) {
            errorFileds = `${item.title} value should not be greater than ${item.maxLength} characters.`;
          }
        });
        this.addFormConstants.forEach((item) => {
          if (item.maxValue && Number(data[item.paramKey]) > item.maxValue) {
            errorFileds = `${item.title} should be less than ${item.maxValue}`;
          }
        });
        if (errorFileds) {
          this.$errorMessage({ message: errorFileds });
          return false;
        }
        const result = await this.$store.dispatch('mdmV2/update', {
          section: this.currentSection,
          data,
          Id: this.isMieone
            ? data[sections[this.currentSection]] || this.selectedRow.id
            : this.selectedRow.id,
          isMieone: this.isMieone,
          packingKeyToCompare: this.packingKeyToCompare || 'code',
        });
        if (!result || result.error) {
          this.$error({ message: result.error });
        } else {
          this.closeSlider();
          this.$success({ message: this.$t('MDM_UPDATE_RECORD') });
        }
      } catch (err) {
        console.log("error",err);
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async remove(values) {
      try {
        const sections = {
          carton: 'code',
          carrier: 'code',
          shipmethod: 'code',
        };
        const data = values;
        const result = await this.$store.dispatch('mdmV2/remove', {
          section: this.currentSection,
          data,
        });
        if (result && result.error) {
          this.$error({ message: result.error });
        } else {
          this.$success({ message: this.$t('MDM_UPDATE_RECORD') });
        }
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    // following is used for search popup
    constructSearchConstants() {
      this.searchParameters.forEach(
        param =>
          (this.searchedParams[`${param.query}`] =
            this.defaultValues[`${param.query}`]),
      );
    },

    constructParams(data) {
      const result = {};
      const dataKeys = Object.keys(data);
      dataKeys.forEach((key) => {
        if (data[key] !== null) {
          result[key] = data[key];
        }
      });
      return result;
    },
    // following is the LIST api call
    searchByParameter(params) {
      this.searchedParams = params;
      this.$store.commit('mdmV2/setPage', 1);
      this.loadMore();
    },
    searchByFilter(params) {
      this.filterParams = params;
      this.$store.commit('mdmV2/setPage', 1);
      this.loadMore();
    },
    async loadMore(endPoint = null, initial = false) {
      try {
        const filter = { page: this.filter.page };
        if (this.searchedParams && Object.keys(this.searchedParams).length) {
          Object.assign(filter, this.searchedParams);
        }
        if (this.filterParams && Object.keys(this.filterParams).length) {
          Object.assign(filter, this.filterParams);
        }
        if (this.currentSection === 'depot') {
          filter.type = 1;
        }
        const params = this.constructParams(filter);
        if (this.currentSection === 'optima input create dn') {
          this.currentSection = 'material';
        }
        if (typeof endPoint !== 'object' && endPoint !== null) {
          this.currentSection = endPoint;
        }
        if (initial) {
          delete params.name;
        }
        const hasData = await this.$store.dispatch('mdmV2/search', {
          section: this.currentSection,
          params,
          isMieone: this.isMieone,
        });
        if (!hasData.length || hasData.error) {
          this.createDnSelectMaterialLoading = false;
        }
        if (hasData.error) {
          this.$error({ message: hasData.error });
        }
        this.loadCheck = this.hasEmpty;
        return hasData;
      } catch (error) {
        this.$error({ message: this.$t('MDM_LISTING_FAILS') });
      }
    },
    resetReject() {
      this.rejectCount = 0;
      this.rejectEvent = null;
    },
    // following will be used for UPLOAD functionality
    async bulkUpload(data, id = null) {
      // @param  {String} xls file path
      try {
        if (this.rejectedAdditionalSection) this.rejectedAdditionalSection = false;
        if (this.rejectedUserMaterialUpload) this.rejectedUserMaterialUpload = false;
        this.resetReject(); // hide out reject download button
        const formData = new FormData();
        formData.append('attachment', data);
        const type = this.currentSection === 'depot' ? '?type=1' : '';
        const result = await this.$store.dispatch('mdmV2/bulkUpload', {
          section: this.currentSection,
          formData,
          subPath: type,
          id,
        });
        if (result && result.error) {
          this.$error({ message: result.error });
        } else {
          this.currentCount = 0;
          this.uploadStatus(id);
        }
      } catch (e) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async getBulkUploadExcel() {
      try {
        console.log('inside getBulkUploadExcel');
        const result = await this.$store.dispatch('mdmV2/getBulkUploadExcel', {
          section: this.currentSection,
        });
        if (result.error) {
          this.$errorMessage({ message: result.error });
        }
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },

    async exportData(entityType = null, entity = null) {
      try {
        const filter = {};
        if (this.searchedParams && Object.keys(this.searchedParams).length) {
          Object.assign(filter, this.searchedParams);
        }
        if (this.filterParams && Object.keys(this.filterParams).length) {
          Object.assign(filter, this.filterParams);
        }
        let params = this.constructParams(filter);
        const sectionType = this.mdmType[this.currentSection];
        params = Object.assign(params, { type: sectionType, entity_type: entityType });
        if (entityType === 'secondary_users' && this.currentSection === 'consignee'
          && params.status === status.INACTIVE
        ) {
          params.status = 0;
        }
        if(this.currentSection === 'freight_zone' && entity){
          params.entity_id = entity;
        }
        const hasData = await this.$store.dispatch('mdmV2/export', {
          section: this.currentSection,
          params,
        });
        if (hasData.error) {
          this.$error({ message: hasData.error });
        } else if (hasData) {
          this.$success({ message: this.$getSuccess(hasData) });
        }
      } catch (error) {
        this.$error({ message: this.$getErr('EXPORT_FAILS') });
      }
    },

    async rejectDownload() {
      const payload = {
        section: this.currentSection,
        transactionIds: this.transactionIds || [],
      };
      console.log("🚀 ~ payload:", payload)
      
      if (this.uploadStatusResponse && this.uploadStatusResponse.uploadType) {
        payload.uploadType = this.uploadStatusResponse.uploadType;
      }
      
      await this.$store.dispatch('mdmV2/rejectDownload', payload);
    },

    async getadditionalExcel() {
      const result = await this.$store.dispatch('mdmV2/getadditionalExcelHeader', {
        section: this.currentSection,
      });
      if (result.error) {
        this.$errorMessage({ message: result.error });
      }
    },

    async uploadStatus(
      uploadType = null,
      currentSection = this.currentSection,
    ) {
      try {
        if (this.currentCount >= this.maxRetryCount) {
          this.$store.commit('mdmV2/setuploadStatus', false);
          this.$infoMessage({
            message: this.$getErr('BULK_UPLOAD_TAKES_LONGER'),
            header: this.$getErr('BULK_UPLOAD_PROCESSING'),
          });
        } else {
          const result = await this.$store.dispatch('mdmV2/uploadStatus', {
            section: currentSection,
            uploadType,
          });
          if (result.code && result.code !== 'PROGRESS') {
            if (result.code === 'COMPLETED') {
              this.transactionIds = result.transaction_ids;
              if (['vehicles_exclude', 'vehicle_detail'].includes(uploadType)) {
                this.rejectCount = 0;
              } else {
                this.rejectCount = result.invalid_count;
              }
              if (result.skipped_count) {
                this.$success({
                  message: this.$getSuccess('BULKUPLOAD_SKIPPED_COUNT', {
                    firstArgument: result.valid_count,
                    secondArgument: result.skipped_count,
                    thirdArgument: result.invalid_count,
                    fourthArgument:
                      result.valid_count +
                      result.skipped_count +
                      result.invalid_count,
                  }),
                });
              } else {
                this.$success({
                  message: this.$getSuccess('BULKUPLOAD_COUNT', {
                    firstArgument: result.valid_count,
                    secondArgument: result.invalid_count,
                    thirdArgument: result.valid_count + result.invalid_count,
                  }),
                });
              }
              if (result.invalid_count === 0) {
                this.rejectedAdditionalSection = false;
              }
              this.uploadStatusResponse = result;
              this.$store.commit('mdmV2/setPage', 1);
              this.loadMore();
            } else {
              this.$store.commit('mdmV2/setuploadStatus', false);
              if (result.duplicate === true) {
                this.$error({
                  message: this.$getErr('BULK_UPLOAD_DUPLICATE_RECORDS'),
                });
              } else {
                this.$error({ message: this.$getErr('BULK_UPLOAD_FAILS') });
              }
            }
          } else if (result.error) {
            this.$error({ message: result.error });
          } else {
            if (
              this.currentSection === 'contract' &&
              result.code === 'PROGRESS'
            ) {
              this.$success({
                message: this.$getSuccess('BULKUPLOAD_STATUS', {
                  firstArgument: result.upload_percentage,
                }),
              });
            }
            this.currentCount += 1;
            setTimeout(() => {
              this.uploadStatus(uploadType, currentSection);
            }, 6000);
          }
        }
      } catch (e) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    /**
     * returns true when value is undefined, null, '', [], {}
     */
    isEmpty(value) {
      return (
        // null or undefined
        value == null ||
        // has length and it's zero
        (value.hasOwnProperty('length') && value.length === 0) ||
        // is an Object and has no keys
        (value.constructor === Object && Object.keys(value).length === 0)
      );
    },
    /**
     * For Download requested uploaded Excel File (Approval MDM Section)
     */
    async downloadUploadedExcel(id) {
      try {
        const response = await this.$store.dispatch('mdmV2/downloadUploadedExcel', {
          section: this.currentSection,
          id,
        });
        if (response.error) {
          this.$error({ message: hasData.error });
        }
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
  },
};
export default MDM;
</script>
